import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type ProductionDeclarationMaterialCommodityOriginDeleteDialogProps = {
  isPending: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
};

export function ProductionDeclarationMaterialCommodityOriginDeleteDialog({
  isPending,
  onConfirm,
  onOpenChange,
  open,
}: ProductionDeclarationMaterialCommodityOriginDeleteDialogProps) {
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t('materialCommodityOrigins.actions.deleteModalTitle')}
          </DialogTitle>
          <DialogDescription>
            {t('materialCommodityOrigins.actions.deleteModalDescription')}
          </DialogDescription>
        </DialogHeader>
        <div className='flex w-full justify-end gap-2'>
          <DialogClose asChild>
            <Button disabled={isPending} type='button' variant='outline'>
              {t('cancel', { ns: 'common' })}
            </Button>
          </DialogClose>
          <Button
            disabled={isPending}
            onClick={onConfirm}
            type='button'
            variant='destructive'
          >
            {t('delete', { ns: 'common' })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
